import { Controller } from "@hotwired/stimulus";

class TabsController extends Controller {
  // This will break once we have more than tab target.
  static selectedIndex: number;

  static targets = ["tab", "panel"];

  declare readonly hasTabTarget: boolean;
  declare readonly tabTarget: HTMLButtonElement;
  declare readonly tabTargets: HTMLButtonElement[];

  declare readonly hasPanelTarget: boolean;
  declare readonly panelTarget: HTMLDivElement;
  declare readonly panelTargets: HTMLDivElement[];

  tabSelected(event: Event) {
    const selectedTab = event.currentTarget as HTMLButtonElement;
    TabsController.selectedIndex = this.tabTargets.findIndex((iteratedTab) => {
      return iteratedTab === selectedTab;
    });
    window.location.hash = TabsController.selectedIndex.toString();
    this.setVisibility();
  }

  setVisibility() {
    this.tabTargets.forEach((iteratedTab, i) => {
      const tabIsActive = i === TabsController.selectedIndex;

      iteratedTab.toggleAttribute("data-tabs-active", tabIsActive);

      const panel = this.panelTargets[i];
      panel.hidden = !tabIsActive;
      this.dispatch("change", {
        target: panel,
        detail: { visible: tabIsActive },
      });
      if (tabIsActive) {
        window.location.hash = i.toString();
      }
    });
  }

  connect(): void {
    // Keep the selected tab on Turbo navigation
    document.documentElement.addEventListener("turbo:load", () => {
      this.setVisibility();
    });

    // Keep stored values if one exists
    if (TabsController.selectedIndex === undefined) {
      // Or use the hash if it has a valid value
      // Do not allow negative values
      const hash = Math.max(parseInt(window.location.hash.slice(1)), 0);
      // Do not allow values that are too higher than the number of tabs
      TabsController.selectedIndex = Math.min(
        hash ? hash : 0,
        this.tabTargets.length - 1
      );
    }

    // Other controllers might depend on the tab being selected at load time
    // but might not be loaded by the time this one is.
    // We trigger the click twice just as an easy way out of that.
    setTimeout(() => {
      this.setVisibility();
    }, 100);
    this.setVisibility();
  }
}

export default TabsController;
